(function ($) {
	if (typeof(wp) === 'object') {
		
		var loadingJSON = false;

		var zelloUserProfile = {
			init: function()
			{
                this.loadUserProfile();
			},
			templateLoader: function(sourceURL, excludedSelector)
			{
                var templateClass = $('.tmpl_wp_su').not(excludedSelector);
                templateClass.each(function() {
                    var thisTemplate = $(this);
					var templateID = thisTemplate.attr('id');
					var templateTarget = $( '.js--' + templateID );
					var templateName = templateID.substr(5);
					var template = wp.template( templateName );

                    $.getJSON( sourceURL, function(data) {
                        templateTarget.html(template(data));
                        zelloUserProfile.extractLetterForPlaceholderImage();
                        loadingJSON = false;
                    });
                });
			},
			loadUserProfile: function()
			{
                if ( !loadingJSON ) {
					var userCode = getUrlParameter('k');
					//var userCode = getUrlID(3);
                    loadingJSON = true;
                    var APIurl = 'https://zello.com/users/';
                    var sourceURL = APIurl;
                    sourceURL = APIurl+'api/'+userCode;
                    //sourceURL = '/json/'+userCode+'.json';
                    zelloUserProfile.templateLoader(sourceURL);

                }
			},
			extractLetterForPlaceholderImage: function()
			{
				var element = $( 'svg.single-channel__item--image text' );
				element.each(function() {
					var singleElement = $(this)
					var singleElementName = singleElement.attr('data-name');
					singleElement.text(singleElementName.substr(0,1).toUpperCase());
				});
			}
		};
		$(document).ready(function() {
			zelloUserProfile.init();
		});
	}
})(jQuery);